import apiClient from "../client";

export interface RemoveParticipantResponse {
  success: boolean;
  message: string;
  data: null;
}

export const removeParticipant = async (
  examAssignmentId: string,
  userId: string
): Promise<RemoveParticipantResponse> => {
  const response = await apiClient.delete(
    `/exam_assignments/${examAssignmentId}/participants/${userId}`
  );
  return response.data;
}; 